import { render, staticRenderFns } from "./AioBillingold.vue?vue&type=template&id=5f90bf01&"
import script from "./AioBillingold.vue?vue&type=script&lang=js&"
export * from "./AioBillingold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports